"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const classnames_template_literals_1 = __importDefault(require("@netlify/classnames-template-literals"));
const Label_1 = __importDefault(require("components/shared/Label/Label"));
const LoadingComponent = ({ size = 24, text = 'Loading', hasText = true, className, textClass = 'loading-text', labelClass, children }) => {
    const LoadingComponentCN = (0, classnames_template_literals_1.default)(`flex
    items-center
    justify-center
    ${className}`);
    // A visible text label becomes the accessible name of the status region; when the
    // caller hides it (hasText=false), fall back to an aria-label so screen readers still
    // announce that content is loading. The animated ring itself is decorative.
    const accessibleLabel = text && hasText ? undefined : text || 'Loading';
    return (react_1.default.createElement("div", { className: LoadingComponentCN, role: "status", "aria-live": "polite", "aria-busy": "true", "aria-label": accessibleLabel },
        react_1.default.createElement("div", { className: "lds-ring relative inline-block", style: { width: size + 'px', height: size + 'px' }, "aria-hidden": "true" },
            react_1.default.createElement("div", { style: { width: size + 'px', height: size + 'px' } }),
            react_1.default.createElement("div", { style: { width: size + 'px', height: size + 'px' } }),
            react_1.default.createElement("div", { style: { width: size + 'px', height: size + 'px' } }),
            react_1.default.createElement("div", { style: { width: size + 'px', height: size + 'px' } })),
        text && hasText && (react_1.default.createElement("div", { className: textClass },
            react_1.default.createElement(Label_1.default, { className: labelClass }, text))),
        children && children));
};
exports.default = LoadingComponent;
